import { reduce } from 'lodash'

export default {
  hasSelected () {
    return reduce(this.schedules, (old, current) => {
      return old || current._selected
    }, false)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/history/index/resources/computed.js